const CNPJ_LENGTH = 14;

const CNPJ_FULL_PATTERN = /^[A-Z0-9]{14}$/;

export function normalizeCnpjDocument(value: string | number): string {
  return value
    .toString()
    .trim()
    .toUpperCase()
    .replace(/[.\-/\s]/g, "");
}

export function formatCnpj(value: string | number): string {
  const normalized = normalizeCnpjDocument(value);

  if (
    normalized.length !== CNPJ_LENGTH ||
    !CNPJ_FULL_PATTERN.test(normalized)
  ) {
    return value?.toString() ?? "";
  }

  return normalized.replace(
    /^(.{2})(.{3})(.{3})(.{4})(.{2})$/,
    "$1.$2.$3/$4-$5",
  );
}
